// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.hint {
  color: rgba(var(--gc-text-color-rgb), 0.65);
  font-size: 0.875rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/v-rest-time-effects/v-rest-time-effects.component.sass"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AACJ;;AACA;EACI,2CAAA;EACA,mBAAA;AAEJ","sourcesContent":[":host\n    display: flex\n    flex-direction: column\n    gap: 1rem\n\n.hint\n    color: rgba(var(--gc-text-color-rgb), 0.65)\n    font-size: 0.875rem\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
